import RulesScreen from '../../Shared/RulesScreen';
import React from 'react';

const AllRulesScreen: React.FC = () => <RulesScreen />;

export default AllRulesScreen;
